import {combineReducers} from 'redux';
import {UserTypes} from 'mattermost-redux/action_types';
import {ActionTypes} from 'utils/constants.jsx';

const defaultState = {
    show: false,
}; 
function filters(state = {}, action) {
    const nextState = {...state};

    switch (action.type) {
        case 'CALL_HISTORY_FILTER': {
            return action.data;
        }
        default:
          return state;
    }
}


function setAddCallHistoryToTask (state = defaultState, action) {
    
    switch (action.type) {
    case ActionTypes.SHOW_ADD_CALL_HISTORY_TO_TASK_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_CALL_HISTORY_TO_TASK_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}

function setAddCallHistoryToNote (state = defaultState, action) {
    
    switch (action.type) {
    case ActionTypes.SHOW_ADD_CALL_HISTORY_TO_NOTE_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_CALL_HISTORY_TO_NOTE_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}


export default combineReducers({
    filters,setAddCallHistoryToTask,setAddCallHistoryToNote
});
